import React from 'react'
import Footer from '../components/footerComponent/footer'
import Lesson from '../components/teacherComponent/lessonComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function LessonPage() {
    return (
        <Layout>
            <Header/>
            <Lesson/>
            <Footer/>
        </Layout>
    );
};